import React, { useState, useEffect } from 'react';
import { getProducts } from '../services/api';
import ProductCard from '../components/ProductCard';
import './New.css';

export default function NewArrivals() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        // Fetch featured and new products
        const res = await getProducts({ featured: 'true' });
        
        let data = [];
        if (Array.isArray(res.data)) data = res.data;
        else if (res.data?.results) data = res.data.results;
        
        if (!cancelled) setProducts(data);
      } catch (err) {
        if (!cancelled) {
          setError(err?.response?.data?.detail || 'Failed to load products');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return (
    <div className="new-arrivals-page">
      {/* ══════════════════════════════════════
          Small Banner
      ══════════════════════════════════════ */}
      <div className="na-banner">
        <img
          src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1600&q=80"
          alt="New Arrivals"
          className="na-banner-img"
        />
        <div className="na-banner-overlay" />
        <div className="na-banner-content">
          <span className="na-banner-tag">✦ Just Dropped</span>
          <h1 className="na-banner-title">New Arrivals</h1>
          <p className="na-banner-subtitle">
            Fresh styles added every week
          </p>
        </div>
      </div>

      {/* ══════════════════════════════════════
          Products Grid
      ══════════════════════════════════════ */}
      <div className="na-container">
        {loading ? (
          <div className="na-loading">
            <div className="na-spinner" />
            <p>Loading new arrivals…</p>
          </div>
        ) : error ? (
          <div className="na-error">⚠️ {error}</div>
        ) : products.length === 0 ? (
          <div className="na-empty">
            <p>No new arrivals yet.</p>
          </div>
        ) : (
          <>
            <div className="na-count">
              {products.length} {products.length === 1 ? 'item' : 'items'}
            </div>
            <div className="na-grid">
              {products.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}


// import React, { useEffect, useMemo, useState } from 'react';
// import { Link } from 'react-router-dom';
// import Navbar from '../components/Navbar';
// import { getProducts } from '../services/api';
// import { useCart } from '../context/CartContext';
// import './NewArrivals.css';

// const NEW_KEYWORDS = ['new', 'latest', 'arriv', 'fresh'];

// function isNewProduct(p) {
//   const name = (p?.name || '').toLowerCase();
//   const tag = (p?.badge || '').toLowerCase();
//   const combined = `${name} ${tag}`;
//   return NEW_KEYWORDS.some((k) => combined.includes(k));
// }

// export default function NewArrivals() {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [search, setSearch] = useState('');

//   const { addToCart } = useCart();

//   useEffect(() => {
//     let mounted = true;

//     async function load() {
//       setLoading(true);
//       setError('');
//       try {
//         const res = await getProducts();
//         if (!mounted) return;
//         const list = Array.isArray(res.data) ? res.data : [];
//         setProducts(list);
//       } catch (e) {
//         if (!mounted) return;
//         console.error(e);
//         setError('Failed to load products');
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     }

//     load();
//     return () => {
//       mounted = false;
//     };
//   }, []);

//   const newArrivals = useMemo(() => {
//     const q = search.trim().toLowerCase();

//     let list = products;
//     // Heuristic: use badge/name if your API doesn't send created_at/sort.
//     list = list.filter((p) => isNewProduct(p));

//     if (q) {
//       list = list.filter((p) => (p?.name || '').toLowerCase().includes(q));
//     }

//     return list;
//   }, [products, search]);

//   return (
//     <>
//       <Navbar />

//       <div className="new-arrivals-page">
//         <section className="new-hero">
//           <div className="new-hero-overlay" />
//           <div className="new-hero-inner">
//             <div className="new-hero-badge">✨ Just Arrived</div>
//             <h1 className="new-hero-title">New Arrivals</h1>
//             <p className="new-hero-subtitle">Fresh picks curated for your next look.</p>

//             <div className="new-search">
//               <span className="new-search-icon"></span>
//               <input
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 placeholder="Search new arrivals..."
//                 aria-label="Search new arrivals"
//               />
//               {search.trim() && (
//                 <button className="new-search-clear" onClick={() => setSearch('')}>
//                   ✕
//                 </button>
//               )}
//             </div>
//           </div>
//         </section>

//         {loading ? (
//           <div className="new-state">Loading new arrivals...</div>
//         ) : error ? (
//           <div className="new-state new-error">{error}</div>
//         ) : newArrivals.length === 0 ? (
//           <div className="new-state">No new arrivals found.</div>
//         ) : (
//           <div className="new-grid">
//             {newArrivals.map((p) => (
//               <article key={p.id} className="new-card">
//                 <Link to={`/product/${p.id}`} className="new-card-media" aria-label={p.name}>
//                   <img
//                     className="new-card-img"
//                     src={p.image ? `http://127.0.0.1:8000${p.image}` : 'https://via.placeholder.com/360x240'}
//                     alt={p.name}
//                   />
//                   {p.badge ? <div className="new-card-badge">{p.badge}</div> : null}
//                 </Link>

//                 <div className="new-card-body">
//                   <div className="new-card-top">
//                     <Link to={`/product/${p.id}`} className="new-card-title">
//                       {p.name}
//                     </Link>
//                     <div className="new-card-price">₹{p.price}</div>
//                   </div>

//                   <div className="new-stock">
//                     {p.stock > 0 ? <span className="in-stock">✅ {p.stock} in stock</span> : <span className="out-stock">❌ Out of stock</span>}
//                   </div>

//                   <button
//                     className="new-add-btn"
//                     onClick={() => addToCart(p)}
//                     disabled={p.stock === 0}
//                   >
//                     {p.stock > 0 ? 'Add to Cart 🛒' : 'Out of Stock'}
//                   </button>
//                 </div>
//               </article>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

